export const dateDiff = (date1, date2) => {
  if (!isValidDate(date1) || !isValidDate(date2)) return { invalid: true };
  let result = {
    years: date2.getYear() - date1.getYear(),
    months: date2.getMonth() - date1.getMonth(),
    days: date2.getDate() - date1.getDate(),
    hours: date2.getHours() - date1.getHours()
  };
  if (date1 > date2) { // swap
    result = dateDiff(date2, date1);
    result.years = -result.years;
    result.months = -result.months;
    result.days = -result.days;
    result.hours = -result.hours;
    return result;
  }

  if (result.hours < 0) {
    result.days--;
    result.hours += 24;
  }
  if (result.days < 0) {
    result.months--;
    // days = days left in date1's month, 
    //   plus days that have passed in date2's month
    let copy1 = new Date(date1.getTime());
    copy1.setDate(32);
    result.days = 32 - date1.getDate() - copy1.getDate() + date2.getDate();
  }
  if (result.months < 0) {
    result.years--;
    result.months += 12;
  }
  return result;
};

export const formatDate = (date, options = {}) => {
  const dateOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    ...options
  };
  if (!isValidDate(date)) return "ungültiges Datum";
  return new Date(date).toLocaleDateString("de-DE", dateOptions);
};

export const formatDateTime = (date, options = {}) => {
  const dateOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "UTC",
    ...options
  };
  if (!isValidDate(date)) return "ungültiges Datum";
  return new Date(date).toLocaleDateString("de-DE", dateOptions);
};

export const formatIsoDate = (date) => {
  if (!isValidDate(date)) return "ungültiges Datum";
  return new Date(date).toISOString().substring(0, 16).replace(/T/, "_");
};

export const isValidDate = (date) => {
  if (!date) return false;
  try {
    const time = new Date(date).getTime();
    return !isNaN(time);
  } catch (err) {
    return false;
  }
};
